export default __webpack_public_path__ + "static/media/black02.d1167061.jpg";